import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const whitfieldConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Whitfield Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Whitfield, FL. Sam\'s Tree Service handles hazardous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_whitfield',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Whitfield',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Whitfield Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide expert tree care to homeowners 
     and businesses throughout <strong>Whitfield</strong>. Located between Sarasota Bay 
     and the busy corridors of Manatee County, this area sees its share of wind exposure 
     and storm activity that stresses trees season after season. When those trees start 
     creating hazards around your home or property, our team is ready to handle it.`,

    `We specialize in <strong>dangerous tree removal and precision trimming</strong> 
     from storm weakened limbs hanging over rooftops and vehicles, to leaning trunks 
     threatening fences and structures, to overgrown canopies that significantly increase 
     your property's wind load risk during hurricane season. We assess every job on site 
     and execute safely.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care across 
     <strong>Whitfield</strong> and the surrounding <strong>North Sarasota and South 
     Manatee</strong> corridor keeping your property protected and your trees healthy 
     all year long.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Whitfield, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Whitfield = () => <LocationPage config={whitfieldConfig} />;
export default Services_Whitfield;
